import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';

const fmt = (n) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(n || 0);

const ETAPAS = [
  { key: 'prospecto',    label: 'Prospecto',     color: 'var(--text-3)' },
  { key: 'contactado',   label: 'Contactado',    color: '#6366f1' },
  { key: 'demo',         label: 'Demo',          color: '#22d3ee' },
  { key: 'propuesta',    label: 'Propuesta',     color: '#f97316' },
  { key: 'negociacion',  label: 'Negociación',   color: '#fbbf24' },
  { key: 'ganado',       label: 'Ganado',        color: '#34d399' },
  { key: 'perdido',      label: 'Perdido',       color: '#f87171' },
];

export default function AdminCRM() {
  const [pipeline, setPipeline] = useState({});
  const [actividades, setActividades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('pipeline');
  const [modal, setModal] = useState(null);
  const navigate = useNavigate();

  const cargar = () => {
    Promise.all([
      api.get('/admin/crm/oportunidades/pipeline'),
      api.get('/admin/crm/actividades?limite=30'),
    ]).then(([p, a]) => {
      setPipeline(p.data);
      setActividades(a.data);
    }).finally(() => setLoading(false));
  };
  useEffect(cargar, []);

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-3)' }}>Cargando...</div>;

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: 'var(--text-1)' }}>CRM</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-3)', fontSize: 14 }}>Pipeline de ventas y seguimiento</p>
        </div>
        <button onClick={() => setModal({})} style={{ padding: '9px 20px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
          + Oportunidad
        </button>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 24, background: 'var(--bg-card)', padding: 4, borderRadius: 10, width: 'fit-content' }}>
        {[{ key: 'pipeline', label: 'Pipeline' }, { key: 'actividades', label: 'Actividades recientes' }].map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{ padding: '8px 20px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 500,
              background: tab === t.key ? '#6366f1' : 'transparent',
              color: tab === t.key ? '#fff' : '#64748b'
            }}>{t.label}</button>
        ))}
      </div>

      {tab === 'pipeline' && (
        <>
          {/* Pipeline summary */}
          <div style={{ display: 'flex', gap: 10, marginBottom: 20, overflowX: 'auto', paddingBottom: 4 }}>
            {ETAPAS.filter(e => !['ganado','perdido'].includes(e.key)).map(e => {
              const d = pipeline[e.key] || { items: [], total: 0 };
              return (
                <div key={e.key} style={{ background: 'var(--bg-card)', borderRadius: 10, padding: '12px 16px', border: `1px solid ${e.color}30`, minWidth: 130, flexShrink: 0 }}>
                  <div style={{ fontSize: 11, color: e.color, fontWeight: 600, marginBottom: 6, textTransform: 'uppercase' }}>{e.label}</div>
                  <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-1)' }}>{d.items.length}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 2 }}>{fmt(d.total)}</div>
                </div>
              );
            })}
          </div>

          {/* Kanban board */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 14, overflowX: 'auto' }}>
            {ETAPAS.filter(e => !['ganado','perdido'].includes(e.key)).map(etapa => (
              <KanbanCol key={etapa.key} etapa={etapa} items={pipeline[etapa.key]?.items || []} onClickItem={(op) => navigate(`/superadmin/clientes/${op.cliente_id}`)} onEdit={(op) => setModal(op)} onMove={async (id, nuevaEtapa) => {
                try {
                  await api.put(`/admin/crm/oportunidades/${id}`, { etapa: nuevaEtapa });
                  cargar();
                } catch { toast.error('Error al mover'); }
              }} />
            ))}
          </div>

          {/* Won / Lost */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginTop: 16 }}>
            {['ganado','perdido'].map(key => {
              const etapa = ETAPAS.find(e => e.key === key);
              const d = pipeline[key] || { items: [], total: 0 };
              return (
                <div key={key} style={{ background: 'var(--bg-card)', borderRadius: 12, padding: 16, border: `1px solid ${etapa.color}30` }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                    <span style={{ color: etapa.color, fontWeight: 700, fontSize: 14 }}>{etapa.label}</span>
                    <span style={{ color: 'var(--text-3)', fontSize: 13 }}>{d.items.length} · {fmt(d.total)}</span>
                  </div>
                  {d.items.slice(0, 4).map(op => (
                    <div key={op.id} style={{ padding: '8px 0', borderBottom: '1px solid var(--border)', fontSize: 12 }}>
                      <div style={{ color: 'var(--text-1s)' }}>{op.titulo}</div>
                      <div style={{ color: 'var(--text-3)' }}>{op.empresa} · {fmt(op.valor_estimado)}</div>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </>
      )}

      {tab === 'actividades' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {actividades.map(a => (
            <div key={a.id} style={{ background: 'var(--bg-card)', borderRadius: 10, padding: '14px 18px', border: '1px solid var(--border)', display: 'flex', gap: 14, alignItems: 'flex-start' }}>
              <div style={{ flexShrink: 0, width: 8, height: 8, borderRadius: '50%', background: TIPO_COLORS[a.tipo] || '#64748b', marginTop: 5 }} />
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontWeight: 600, color: 'var(--text-1)', fontSize: 14 }}>{a.titulo}</span>
                  <div style={{ display: 'flex', gap: 10, fontSize: 12 }}>
                    <span style={{ color: 'var(--text-3)' }}>{a.fecha}</span>
                    <TipoBadge tipo={a.tipo} />
                  </div>
                </div>
                <span style={{ color: '#6366f1', fontSize: 12, cursor: 'pointer' }} onClick={() => navigate(`/superadmin/clientes/${a.cliente_id}`)}>{a.empresa}</span>
                {a.descripcion && <p style={{ margin: '4px 0 0', color: 'var(--text-3)', fontSize: 12 }}>{a.descripcion}</p>}
                {a.resultado && <p style={{ margin: '4px 0 0', color: '#34d399', fontSize: 12 }}>→ {a.resultado}</p>}
              </div>
            </div>
          ))}
          {!actividades.length && <div style={{ textAlign: 'center', color: 'var(--text-4)', padding: 40 }}>Sin actividades recientes</div>}
        </div>
      )}

      {modal !== null && <OportunidadModal data={Object.keys(modal).length ? modal : null} onClose={() => setModal(null)} onSaved={() => { setModal(null); cargar(); }} />}
    </div>
  );
}

const TIPO_COLORS = { llamada:'#22d3ee', email:'#6366f1', reunion:'#fbbf24', nota:'#94a3b8', demo:'#34d399', propuesta:'#f97316', soporte:'#a78bfa', otro:'#64748b' };
const TipoBadge = ({ tipo }) => (
  <span style={{ fontSize: 10, padding: '1px 8px', borderRadius: 10, background: (TIPO_COLORS[tipo] || '#64748b') + '22', color: TIPO_COLORS[tipo] || '#64748b' }}>{tipo}</span>
);

function KanbanCol({ etapa, items, onEdit, onMove }) {
  return (
    <div style={{ background: 'var(--bg-card)', borderRadius: 12, padding: 12, border: `1px solid ${etapa.color}20`, minHeight: 200 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10, alignItems: 'center' }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: etapa.color, textTransform: 'uppercase' }}>{etapa.label}</span>
        <span style={{ fontSize: 11, color: 'var(--text-3)', background: 'var(--bg-app)', padding: '1px 7px', borderRadius: 10 }}>{items.length}</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {items.map(op => (
          <div key={op.id} style={{ background: 'var(--bg-app)', borderRadius: 8, padding: 10, border: '1px solid var(--border)', cursor: 'pointer' }} onClick={() => onEdit(op)}>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-1s)', marginBottom: 4, lineHeight: 1.4 }}>{op.titulo}</div>
            {op.empresa && <div style={{ fontSize: 11, color: 'var(--text-3)', marginBottom: 4 }}>{op.empresa}</div>}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 11, color: '#22d3ee', fontWeight: 600 }}>{new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(op.valor_estimado)}</span>
              <span style={{ fontSize: 10, color: 'var(--text-3)' }}>{op.probabilidad}%</span>
            </div>
            {op.plan_nombre && <div style={{ marginTop: 4, fontSize: 10, padding: '1px 6px', borderRadius: 8, background: (op.plan_color || '#64748b') + '22', color: op.plan_color || '#64748b', display: 'inline-block' }}>{op.plan_nombre}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}

function OportunidadModal({ data, onClose, onSaved }) {
  const esNuevo = !data?.id;
  const [planes, setPlanes] = useState([]);
  const [form, setForm] = useState({
    titulo: data?.titulo || '',
    empresa: data?.empresa || '',
    contacto: data?.contacto || '',
    email: data?.email || '',
    telefono: data?.telefono || '',
    etapa: data?.etapa || 'prospecto',
    valor_estimado: data?.valor_estimado || 0,
    plan_id: data?.plan_id || '',
    sillas_estimadas: data?.sillas_estimadas || 0,
    probabilidad: data?.probabilidad || 50,
    fecha_cierre_estimada: data?.fecha_cierre_estimada || '',
    notas: data?.notas || '',
  });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inputStyle = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-app)', color: 'var(--text-1s)', fontSize: 13, outline: 'none', boxSizing: 'border-box' };

  useEffect(() => { api.get('/admin/planes').then(r => setPlanes(r.data)).catch(() => {}); }, []);

  const guardar = async () => {
    if (!form.titulo) return toast.error('El título es requerido');
    setSaving(true);
    try {
      if (esNuevo) {
        await api.post('/admin/crm/oportunidades', form);
        toast.success('Oportunidad creada');
      } else {
        await api.put(`/admin/crm/oportunidades/${data.id}`, form);
        toast.success('Oportunidad actualizada');
      }
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error');
    } finally { setSaving(false); }
  };

  const eliminar = async () => {
    if (!window.confirm('¿Eliminar oportunidad?')) return;
    await api.delete(`/admin/crm/oportunidades/${data.id}`);
    toast.success('Eliminada');
    onSaved();
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#00000080', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
      <div style={{ background: 'var(--bg-card)', borderRadius: 16, padding: 28, width: '100%', maxWidth: 580, border: '1px solid var(--border)', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
          <h2 style={{ margin: 0, fontSize: 17, color: 'var(--text-1)' }}>{esNuevo ? 'Nueva Oportunidad' : 'Editar Oportunidad'}</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-3)', cursor: 'pointer', fontSize: 20 }}>×</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          <div style={{ gridColumn: '1/-1' }}>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Título *</label>
            <input style={inputStyle} value={form.titulo} onChange={e => set('titulo', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Empresa</label>
            <input style={inputStyle} value={form.empresa} onChange={e => set('empresa', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Contacto</label>
            <input style={inputStyle} value={form.contacto} onChange={e => set('contacto', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Email</label>
            <input style={inputStyle} type="email" value={form.email} onChange={e => set('email', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Teléfono</label>
            <input style={inputStyle} value={form.telefono} onChange={e => set('telefono', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Etapa</label>
            <select style={inputStyle} value={form.etapa} onChange={e => set('etapa', e.target.value)}>
              {ETAPAS.map(e => <option key={e.key} value={e.key}>{e.label}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Probabilidad (%)</label>
            <input style={inputStyle} type="number" min="0" max="100" value={form.probabilidad} onChange={e => set('probabilidad', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Plan de interés</label>
            <select style={inputStyle} value={form.plan_id} onChange={e => set('plan_id', e.target.value)}>
              <option value="">Sin plan específico</option>
              {planes.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Sillas estimadas</label>
            <input style={inputStyle} type="number" value={form.sillas_estimadas} onChange={e => set('sillas_estimadas', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Valor estimado (COP)</label>
            <input style={inputStyle} type="number" value={form.valor_estimado} onChange={e => set('valor_estimado', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Cierre estimado</label>
            <input style={inputStyle} type="date" value={form.fecha_cierre_estimada} onChange={e => set('fecha_cierre_estimada', e.target.value)} />
          </div>
          <div style={{ gridColumn: '1/-1' }}>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Notas</label>
            <textarea style={{ ...inputStyle, minHeight: 70, resize: 'vertical' }} value={form.notas} onChange={e => set('notas', e.target.value)} />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 22 }}>
          {!esNuevo && <button onClick={eliminar} style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid #f87171', background: 'transparent', color: '#f87171', cursor: 'pointer', fontSize: 13 }}>Eliminar</button>}
          <div style={{ display: 'flex', gap: 10, marginLeft: 'auto' }}>
            <button onClick={onClose} style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-2)', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
            <button onClick={guardar} disabled={saving} style={{ padding: '9px 20px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>{saving ? 'Guardando...' : 'Guardar'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
